@if (app.customer == 'omp') {
  <span>
    @for (url of app.list.profile.urls; track url) {
      <div>
        <a [href]="getOMPDocumentationURLs(url)" target="_blank">
          {{ app.getText(url) }}
        </a>
      </div>
    }
  </span>
}
<div class="mt-4">
  @for (url of links; track url) {
    <div>
      @if (app.customer !== 'coop' && app.customer !== 'oc') {
        <div>
          @if (url.OM) {
            <span>
              <a target="_blank" [href]="url.OM">
                {{ app.text.profile.userOMManual }}
              </a>
            </span>
          }
          @if (url.RM) {
            <span>
              <a target="_blank" [href]="url.RM">
                {{ app.text.profile.userRMManual }}
              </a>
            </span>
          }
        </div>
      }
    </div>
  }
</div>
